<span class="attachment" *ngIf="file else noFile">
    <i class="fas fa-paperclip"></i>
    <strong>{{file.name}}</strong>
    <i (click)="deleteFile()" class="fa fa-trash deleteAction"></i>
</span>

<ng-template #noFile>
    <div class="row">
        <div class="col-xs-12 text-center" [i18n]="'file-drop.no-file'"></div>
    </div>
</ng-template>
